import { useContext, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import './Login.css'
import { HiMiniGiftTop } from "react-icons/hi2";
import { loginCall } from '../../apiCalls';
import {AuthContext} from '../../context/AuthContext';
import { CircularProgress } from '@mui/material';
import React from 'react';

export default function Login() {
  const email = useRef();
  const password = useRef();
  const {user, isLoading, dispatch} = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname;

  const handleClick = async (e) => {
    e.preventDefault();
    await loginCall({email:email.current.value, password:password.current.value},
      dispatch);
  };

  useEffect(() => {
    if(user && from){
      navigate(from, { replace: true });
    } else if (user){
      navigate('/');
    }
  }, [user, from, navigate])

  return (
    <div className="login-container">
        <div className="loginWrapper">
          <div className="login-title-container">
            <p className='login-title'>Receive gifts</p> 
              <p className='login-title'>from people who</p>
              <p className='login-title-color'>love you</p>
          </div>
          <form className="loginBox" onSubmit={handleClick}>
            <input 
              placeholder='Email'
              type='email'  
              className="loginInput" 
              ref={email} required/>
            <input 
              placeholder='Password' 
              type='password' 
              minLength={6} 
              className="loginInput" 
              ref={password}
              required 
            />
            {/* <span className="loginForgot">Forgot Password?</span> */}
              <button className="loginButton" type="Submit" disabled={isLoading}>
                {isLoading ? <CircularProgress size="20px"/> : "Login"}
              </button>
          </form>
          <div className="login-bottom-container">
            <HiMiniGiftTop className='login-give-icon'/>
            <p className='login-site'>g-ve.com</p>
            <p className='login-bottom-p'>send items & currency anonymously</p>
          </div>
        </div>
    </div>
  )
}
